import { useFormContext } from 'react-hook-form'
import { BasicInput } from '@/view/components/BasicInput'
import { Button } from '@/view/components/ui/button'
import { CreditClientFormData } from './schema'
import { zipCodeMask } from '@/app/utils/zipCodeFormater'
import { BasicSelect } from '@/view/components/BasicSelect'
import { states } from '@/app/utils/states'
import { customStyles } from './CustomStyles'

interface AddressStepProps {
  visible: boolean
  onNext: () => void
  onBack: () => void
  onCepRequest: (cep: string) => void
}

export function AddressStep({
  visible,
  onNext,
  onBack,
  onCepRequest,
}: AddressStepProps) {
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext<CreditClientFormData>()

  const handleNext = () => {
    onNext()
  }

  const handleCepRequest = (e: React.FocusEvent<HTMLInputElement>) => {
    const cep = e.target.value.replace(/\D/g, '')
    if (cep.length === 8) {
      onCepRequest(e.target.value)
    }
  }

  const isFormValid = () => {
    const address = watch('address')
    return !!(
      address.zipCode &&
      address.street &&
      address.neighborhood &&
      address.city &&
      address.state
    )
  }

  if (!visible) return null

  return (
    <div className="flex flex-col">
      <div className="mb-5">
        <h1 className="mb-2 text-xl font-semibold text-black01 sm:text-2xl">
          Informe seu endereço completo
        </h1>
      </div>
      <div className="flex flex-col gap-4">
        <BasicInput
          {...register('address.zipCode')}
          label="CEP"
          type="text"
          placeholder="00000-000"
          onInput={zipCodeMask}
          maxLength={9}
          onBlur={(e) => handleCepRequest(e)}
          error={errors.address?.zipCode?.message}
        />

        <BasicInput
          {...register('address.street')}
          label="Rua"
          placeholder="Av. Brasil"
          error={errors.address?.street?.message}
        />
        <div className="flex items-center gap-4">
          <BasicInput
            {...register('address.number')}
            label="Número"
            placeholder="1234"
            error={errors.address?.number?.message}
          />

          <BasicInput
            {...register('address.complement')}
            label="Complemento"
            placeholder="Apto 101"
            error={errors.address?.complement?.message}
          />
        </div>

        <BasicInput
          {...register('address.neighborhood')}
          label="Bairro"
          placeholder="Centro"
          error={errors.address?.neighborhood?.message}
        />

        <div className="flex items-center gap-4">
          <BasicInput
            {...register('address.city')}
            label="Cidade"
            placeholder="São Paulo"
            error={errors.address?.city?.message}
          />

          <BasicSelect
            name="address.state"
            label="UF"
            options={states}
            placeholder="Selecione o seu estado"
            styles={customStyles}
            error={errors.address?.state?.message}
          />
        </div>
      </div>

      <div className="mt-24 flex w-full justify-end gap-4">
        <Button
          type="button"
          variant="outline"
          onClick={onBack}
          className="w-full rounded-full bg-gray01 px-8 py-3"
        >
          Voltar
        </Button>
        <Button
          type="button"
          onClick={handleNext}
          disabled={!isFormValid()}
          className="w-full rounded-full bg-primary px-8 py-3"
        >
          Continuar
        </Button>
      </div>
    </div>
  )
}
